package com.essntl.uikit.components.chat.contact

data class ContactUiState(
    val name: String?,
    val phoneNumber: String?,
    val type: ContactType?,
    val isOnline: Boolean = true,
) {
    val initials
        get() = name?.split(" ")
            ?.filter { it.isNotEmpty() }
            ?.map { it.first().uppercaseChar() }
            ?.joinToString("")

    enum class ContactType {
        Supplier, Client, TravelAgent, Contact;

        val value
            get() = when (this) {
                Supplier -> "Supplier"
                Client -> "Traveller"
                TravelAgent -> "Travel agent"
                Contact -> "Contact"
            }
    }

    companion object {
        val empty =
            ContactUiState(
                name = null,
                phoneNumber = null,
                type = null,
            )
    }
}
